import type { FaireThemeEntity } from "../../entity_types/theme";

export const symbolic_gold_charms: FaireThemeEntity = {
  token: "symbolic-gold-charms",
  type: "theme",
  name: "Symbolic Gold Charms",
  description: "Small, meaningful gold-plated necklaces that serve as perfect impulse gifts. These symbolic pendants are ideal for customers looking for a personal touch during their visit.",
  teaser: "Your business type is a brick-and-mortar store where impulse items like affordable necklaces can easily be displayed near the checkout area of your lounge.",
  detail: "Your cart contains a Virgin Mary Religious Necklace, demonstrating an interest in carrying accessible, symbolic jewelry at a competitive price point.",
  bgColor: "#D4E6F1",
  tileBgColor: "#6b5e31",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_4v9244fwdr",
    "p_dx7acsu3hp",
    "p_41zr0qcfiq",
    "p_zawvgc9ngz",
    "p_gx85dug7cv",
    "p_59nax6dhup",
    "p_m357kpvrd3",
    "p_cgz8dz7xh3",
    "p_hthdxesrat",
    "p_9nmydvk8m8",
    "p_66kdqpvmkw",
    "p_jgfwvvnwkw",
    "p_eguhqyz7v7",
    "p_47aj5q5rp5",
    "p_qrc4aaw3a2",
    "p_hchkkh2qyn",
    "p_az2ex9ad55",
    "p_kjztncjy5n",
    "p_su8dqcjh5t",
    "p_q5h4s4hckd",
    "p_4qkuw7mime",
    "p_zdec2j3n6j",
    "p_hrgh7zfu4r",
    "p_vs4xr7yk36",
    "p_5964gt9sjb",
    "p_qw2kz9vwht",
    "p_h2ww6ungg7",
    "p_p7nfyqkufk",
    "p_4hsuyzyx5f",
    "p_vg6j57tj6d",
    "p_pfe2ab3s3n",
    "p_cybgv72eqj",
    "p_hpaasbytec",
    "p_4tnc6zju82",
    "p_6meqqhgpaa",
    "p_6f7sshvf92",
    "p_582dabhcpy",
    "p_rbgm27uw3v",
    "p_r92h762x2f",
    "p_3hqschs56r",
    "p_6xmdsy6sv8",
    "p_ptvks7p8uq",
    "p_p2g4pkkfxs",
    "p_n5c6azucu8",
    "p_8azzac2ram",
    "p_y5v8fd8yg4",
    "p_hgdwhb6qju",
    "p_nz7euf94ma",
    "p_t89cymg9a7",
    "p_dekscgag73",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
